export const StatusColors = [{
    id:    '566bc9a5-e98c-4a77-848a-3e0ad8446efe',
    label: 'Open',
    color: '#FFF200'
},
{
    id:    '93d1b9c3-da44-4ef0-94e1-537f3772dadd',
    label: 'Scheduled',
    color: '#F9835A'
},
{
    id:    '032afc27-c97d-4a3a-bb8a-338a25a55d0c',
    label: 'Rescheduled',
    color: '#e57686'
},
{
    id:    '25255d07-af96-42fe-868f-e8c1987449d7',
    label: 'Tech Dispatched',
    color: '#ffac40'
},
{
    id:    'dfd7c562-061c-40a9-8300-d7817141df86',
    label: 'Tech Arrived',
    color: '#7575AA'
},
{
    id:    '2ed6311c-7f2e-4fad-a7c0-6e2eebe1ab12',
    label: 'Work Started',
    color: '#62b0bc'
},
{
    id:    'ab65fd5b-c93e-4511-8120-da35f6f32205',
    label: 'Work Complete',
    color: '#84c971'
},
{
    id:    'd3699c99-d9c9-4d94-aba6-b08a932d297e',
    label: 'Complete',
    color: '#84c971'
},
{
    id:    'db7784f2-48c5-438c-b7f0-7850e37e5cb7',
    label: 'Canceled',
    color: '#000000'
}];
